import { ApolloError } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { getErrorMessage, getErrorCode } from 'utils/apolloErrorParser'

interface useErrorSnackbarReturn {
  enqueueApolloError: (error?: ApolloError | unknown) => void
  enqueueErrorMessage: (message: string) => void
}

function useErrorSnackbar(): useErrorSnackbarReturn {
  const { enqueueSnackbar } = useSnackbar()

  function enqueueApolloError(error?: ApolloError | unknown) {
    enqueueSnackbar(getErrorMessage(error as ApolloError), {
      // @ts-ignore
      'data-testid': `snackbar-apollo-error`,
      // @ts-ignore
      'data-error-code': getErrorCode(error),
    })
  }
  function enqueueErrorMessage(message: string) {
    enqueueSnackbar(message, {
      // @ts-ignore
      'data-testid': 'snackbar-message-error',
    })
  }

  return {
    enqueueApolloError,
    enqueueErrorMessage,
  }
}

export default useErrorSnackbar
